import ContactInfo from './contactInfo';
import EmploymentInfo from './employmentInfo';
import Designations from './designations';
import Review from './review';

export default class Editable {
  constructor() {
    this.contactInfo = new ContactInfo();
    this.employmentInfo = new EmploymentInfo();
    this.designations = new Designations();
    this.review = new Review();
  }

  loadData(payload) {
    if (payload.PFG_Wrapper?.Editable) {
      this.contactInfo.loadData(payload.PFG_Wrapper.Editable);
      this.employmentInfo.loadData(payload.PFG_Wrapper.Editable);
      this.designations.loadData(payload.PFG_Wrapper.Editable);
      this.review.loadData(payload.PFG_Wrapper.Editable);
    }
  }
}
